// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitInfoRect from "./TraitInfoRect.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function TraitsList$SubList(Props) {
  var onTraitSelected = Props.onTraitSelected;
  var stats = Props.stats;
  var traits = Props.traits;
  var totalEntries = Props.totalEntries;
  return React.createElement("div", {
              className: CssJs.style([
                    CssJs.display(CssJs.grid),
                    CssJs.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              "autoFill",
                              {
                                NAME: "minmax",
                                VAL: [
                                  CssJs.px(126),
                                  CssJs.fr(1)
                                ]
                              }
                            ]
                          }]),
                    CssJs.gridGap(CssJs.px(12))
                  ])
            }, Belt_Array.mapWithIndex(traits, (function (idx, traitId) {
                    var stats1 = Belt_Option.map(Js_dict.get(stats, traitId + "__1"), (function (ts) {
                            return [
                                    Global.f(ts.count) / Global.f(totalEntries),
                                    ts.place,
                                    ts.top4,
                                    ts.won
                                  ];
                          }));
                    var stats2 = Belt_Option.map(Js_dict.get(stats, traitId + "__2"), (function (ts) {
                            return [
                                    Global.f(ts.count) / Global.f(totalEntries),
                                    ts.place,
                                    ts.top4,
                                    ts.won
                                  ];
                          }));
                    var stats3 = Belt_Option.map(Js_dict.get(stats, traitId + "__3"), (function (ts) {
                            return [
                                    Global.f(ts.count) / Global.f(totalEntries),
                                    ts.place,
                                    ts.top4,
                                    ts.won
                                  ];
                          }));
                    if (stats1 === undefined) {
                      return null;
                    }
                    var tmp = {
                      stats1: stats1,
                      traitId: traitId,
                      key: String(idx)
                    };
                    if (onTraitSelected !== undefined) {
                      tmp.onTraitSelected = Caml_option.valFromOption(onTraitSelected);
                    }
                    if (stats2 !== undefined) {
                      tmp.stats2 = Caml_option.valFromOption(stats2);
                    }
                    if (stats3 !== undefined) {
                      tmp.stats3 = Caml_option.valFromOption(stats3);
                    }
                    return React.createElement(TraitInfoRect.make, tmp);
                  })));
}

var SubList = {
  make: TraitsList$SubList
};

function TraitsList(Props) {
  var onTraitSelected = Props.onTraitSelected;
  var stats = Props.stats;
  var totalEntries = Props.totalEntries;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var tmp = {
    stats: stats,
    traits: Sd.allOrigins(set),
    totalEntries: totalEntries
  };
  if (onTraitSelected !== undefined) {
    tmp.onTraitSelected = Caml_option.valFromOption(onTraitSelected);
  }
  var tmp$1 = {
    stats: stats,
    traits: Sd.allClasses(set),
    totalEntries: totalEntries
  };
  if (onTraitSelected !== undefined) {
    tmp$1.onTraitSelected = Caml_option.valFromOption(onTraitSelected);
  }
  return React.createElement("div", {
              className: "flex w-full flex-col md:flex-row"
            }, React.createElement("div", {
                  className: "flex-1"
                }, React.createElement(ContentSection.make, {
                      title: t("Origins"),
                      children: React.createElement(TraitsList$SubList, tmp)
                    })), React.createElement("div", {
                  className: "pt-8 md:pt-0 md:pl-8 flex-1"
                }, React.createElement(ContentSection.make, {
                      title: t("Classes"),
                      children: React.createElement(TraitsList$SubList, tmp$1)
                    })));
}

var make = TraitsList;

export {
  SubList ,
  make ,
  
}
/* Sd Not a pure module */
